// GENERATED by scripts/build-icons.mjs from icons/corner-down-right.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const CornerDownRight = createIcon('corner-down-right', [
  ['path', { d: "m15 10 5 5-5 5" }],
  ['path', { d: "M4 4v7a4 4 0 0 0 4 4h12" }],
])
